import React from 'react';

import { Icon, Layout, Text } from 'ds';
import { formatDate } from 'shared/time';
import {
  selectOnboardingServiceStartDate,
  selectOnboardingStandardDay,
  selectOnboardingTouchUpDay
} from 'store/CleaningService/selectors';
import { useAppSelector } from 'store/hooks';

import { getFirstOccurrenceOfWeekday } from './utils';

interface CleaningServiceRepeatCardProps {
  cleaningType: 'standard' | 'touch-up';
}

const dayToName: Record<number, string> = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday'
};

const CleaningServiceRepeatCard: React.FC<CleaningServiceRepeatCardProps> = ({ cleaningType }) => {
  const touchUpDay = useAppSelector(selectOnboardingTouchUpDay);
  const standardDay = useAppSelector(selectOnboardingStandardDay);
  const serviceStartDate = useAppSelector(selectOnboardingServiceStartDate);

  if (
    (!touchUpDay && cleaningType === 'touch-up') ||
    (!standardDay && cleaningType === 'standard') ||
    !serviceStartDate
  ) {
    return null;
  }
  const day = cleaningType === 'standard' ? dayToName[standardDay!] : dayToName[touchUpDay!];

  const startDate = getFirstOccurrenceOfWeekday(
    cleaningType === 'standard' ? standardDay : touchUpDay,
    serviceStartDate
  );

  return (
    <Layout
      __style={{
        borderRadius: '12px',
        background: `
          linear-gradient(white, white) padding-box,
          linear-gradient(85.55deg, #0078ff 0%, #8e5ff4 100%) border-box
        `,
        border: '1px solid transparent'
      }}
      borderRadius={12}
    >
      <Layout
        __style={{
          borderRadius: '10px'
        }}
        direction="row"
        gap={12}
        color="purple-gradient-transparent"
        padding={12}
      >
        <Icon name="calendarCheckmark" size="sm" color="gray-900" stroke={2} />
        <Text size="body-sm" color="gray-900">
          Your{' '}
          <span style={{ fontWeight: 600, fontSize: '14px', lineHeight: '20px', letterSpacing: '0.02em' }}>
            {cleaningType}
          </span>{' '}
          cleanings will repeat every{' '}
          <span style={{ fontWeight: 600, fontSize: '14px', lineHeight: '20px', letterSpacing: '0.02em' }}>{day}</span>,
          starting{' '}
          <span style={{ fontWeight: 600, fontSize: '14px', lineHeight: '20px', letterSpacing: '0.02em' }}>
            {formatDate({ date: startDate ?? '', format: 'MED_WITH_YEAR' })}
          </span>
          .
        </Text>
      </Layout>
    </Layout>
  );
};

export default CleaningServiceRepeatCard;
